import React from 'react';
import classnames from 'classnames';

import styles from './WebCopy.module.scss';

type WebCopyType = 'Default' | 'Description' | 'Error' | 'Label' | 'Statement';

interface WebCopyProps {
  /** @string - Classname to be passed to the wrapper div */
  className?: string;
  /** @WebCopyType - Type variation */
  type?: WebCopyType;
}

const WebCopy: React.FC<WebCopyProps> = ({ children, className, type = 'Default' }) => {
  return (
    <div
      className={classnames(className, {
        [styles[`type-${type}`]]: type,
      })}
    >
      {children}
    </div>
  );
};

export default WebCopy;
